import React from 'react';
import { Form, Row, Col } from 'antd';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { AuthUser, EUserTier } from '../../interfaces';
import { StatusSection, StyledCard, StyledInput, StyledTag } from './styles';
import { Separator } from '../ui/separator';

type ProfileSectionProps = {
  user: AuthUser;
};

export const ProfileSection = ({ user }: ProfileSectionProps) => {
  return (
    <StyledCard>
      <Form
        layout="vertical"
        initialValues={{
          firstName: user?.firstName,
          lastName: user?.lastName,
          email: user?.email,
        }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="firstName" label="First Name">
              <StyledInput type="text" disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="lastName" label="Last Name">
              <StyledInput type="text" disabled />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item name="email" label="Email">
          <StyledInput type="email" disabled />
        </Form.Item>
      </Form>

      <Separator className="my-6" />

      <StatusSection>
        <span className="label">Account Tier</span>
        <div className="value">
          <StyledTag
            color={user.accountType === EUserTier.INTERNAL ? 'blue' : 'default'}
          >
            {user.accountType?.toLowerCase() || 'standard'}
          </StyledTag>
        </div>

        <span className="label">Email Status</span>
        <div className="value">
          {user.isVerified ? (
            <StyledTag color="success" icon={<CheckCircleFilled />}>
              Verified
            </StyledTag>
          ) : (
            <StyledTag color="warning" icon={<CloseCircleFilled />}>
              Unverified
            </StyledTag>
          )}
        </div>
      </StatusSection>
    </StyledCard>
  );
};
